<div class="util-user" data-test="profile-nav">
  <div>
    <cigna-icon type="profile-head" class="util-user__img"></cigna-icon>
  </div>

  <span class="util-user__name" data-test="header-user-name"
    >{{ firstName }} {{ lastName }}</span
  >
  <cigna-icon type="caret-down" class="util-dropdown"></cigna-icon>

  <div class="util-user__links">
    <div class="util-user__link-item util-user__link-item--static">
      Signed in as (<span cg-test="userid" data-test="header-user-id">{{
        userid
      }}</span
      >)
    </div>

    <ng-container *ngFor="let link of profileLinks">
      <ng-container *ngIf="!link.openExternal; else externalLink">
        <a
          [href]="link.path"
          [routerLink]="link.path"
          class="util-user__link-item util-user__link-item--clickable"
          [class.cg-disabled-link]="isImpersonator && !link.allowImpersonator"
          [class.cg-non-clickable]="isImpersonator && !link.allowImpersonator"
          [attr.data-test]="'profile-nav-child-' + link.identifier"
          [cignaTrackClicks]="[
            'trackEventOther',
            link.title,
            'ac-NV002-Name Subnav',
            { prop20: 'nav-sub-utility' }
          ]"
          >{{ link.title }}</a
        >
      </ng-container>

      <ng-template #externalLink>
        <a
          class="util-user__link-item util-user__link-item--clickable"
          cg-disabled-link
          [href]="link.path"
          target="_blank"
          rel="noopener noreferrer"
          [class.cg-disabled-link]="isImpersonator && !link.allowImpersonator"
          [class.cg-non-clickable]="isImpersonator && !link.allowImpersonator"
          [attr.data-test]="'profile-nav-child-' + link.identifier"
          [cignaTrackClicks]="[
            'trackEventOther',
            link.title,
            'ac-NV002-Name Subnav',
            { prop20: 'nav-sub-utility' }
          ]"
          >{{ link.title }}
          <cigna-icon
            type="external-link"
            class="cg-mat-icon-link-right cg-color-digital-blue"
            [class.cg-disabled-link]="isImpersonator && !link.allowImpersonator"
            style="vertical-align: middle"
          ></cigna-icon>
        </a>
      </ng-template>
    </ng-container>
  </div>
</div>
